<template>
  <v-data-table
    :headers="headers"
    :items="users"
    item-key="id"
    :items-per-page="50"
    class="mb-8"
  >
    <template v-slot:top>
      <v-dialog
        v-model="loading"
        persistent
        width="300"
      >
        <v-card height="190" class="text-center">
          <v-progress-circular
            :indeterminate="loading"
            :size="100"
            color="primary"
            class="mt-4 "
          >Loading...
          </v-progress-circular>
          <v-card-actions>
            <v-btn class="ml-auto my-2" color="primary" @click="loading=false">close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog" persistent max-width="390">
        <v-card>
          <v-card-title class="headline">編集</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.nickname"
                    label="ユーザー名"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.message"
                    label="メッセージ"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-file-input v-model="editedItem.imageFile" label="画像を選択" @change="imageChanged"></v-file-input>
                  <v-img :src="editedItem.avatar" 
                    width="100px" 
                    v-if="editedItem.avatar"
                  ></v-img>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="save">保存</v-btn>
            <v-btn color="green darken-1" text @click="close">キャンセル</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template v-slot:item.avatar="{ item }" >
      <v-img :src="item.avatar" 
        width="100px" 
      ></v-img>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon @click="editItem(item)">
        mdi-pencil
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
  import mixin from '@/util/mixin'

  export default {
    mixins: [mixin],
    data () {
      return {
        editedIndex: -1,
        editedItem: {},
        loading: true,
        dialog: false,
        headers: [
          {
            text: 'ID',
            align: 'start',
            sortable: false,
            value: 'id',
          },
          { text: 'ユーザー名', value: 'nickname', sortable: false },
          { text: 'メッセージ', value: 'message', sortable: false },
          { text: '画像', value: 'avatar', sortable: false },
          { text: '最終ボーナス受取日時', value: 'bonusReceivedAt', sortable: false },
          { text: '最終ログイン日時', value: 'lastLoginAt', sortable: false },
          { text: '回答数', value: 'answerCount', sortable: false },
          { text: '操作', value: 'actions', sortable: false },
        ],
        users: []
      }
    },
    methods: {
      close () {
        this.dialog = false
        this.editedIndex = -1
        this.editedItem = {}
      },
      save () {
        if (this.editedItem.imageFile) {
          const imageRef = this.$fb.ref(this.$fb.storage, this.editedItem.avatarUrl)
          this.$fb.uploadBytesResumable(imageRef, this.editedItem.imageFile)
        }
        const userRef = this.$fb.doc(this.$fb.firestore, 'users', this.editedItem.id)
        this.$fb.updateDoc(userRef, {
          nickname: this.editedItem.nickname,
          message: this.editedItem.message,
        }).then(() => {
          Object.assign(this.users[this.editedIndex], this.editedItem)
          this.close()
        })
      },
      imageChanged (file) {
        if (file !== undefined && file !== null) {
          const fr = new FileReader()
          fr.readAsDataURL(file)
          fr.addEventListener('load', () => {
            this.editedItem.avatar = fr.result
          })
        } else {
          this.editedItem.avatar = ''
        }
      },
      editItem(item) {
        this.editedIndex = this.users.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      init () {
        this.$fb.getDocs(this.$fb.query(this.$fb.collection(this.$fb.firestore, 'users')
        .withConverter(this.userConverter),
          this.$fb.limit(1000)))
        .then(async (userSnap) => {
          const users = await Promise.all(userSnap.docs
            .filter((userDoc) => userDoc.id.length !== 5)
            .map(async (userDoc) => {
              const user = userDoc.data()
              const imageRef = this.$fb.ref(this.$fb.storage, user.avatarUrl)
              user.avatar = user.avatarUrl ? await this.$fb.getDownloadURL(imageRef) : null
              return {...user, id: userDoc.id}
            })
          )
          users.sort((a, b) => !a.lastLoginAt ? 1 : !b.lastLoginAt ? -1 : b.lastLoginAt.getTime() - a.lastLoginAt.getTime())
          this.users = users
          this.loading = false
        }).catch(error => {
          console.error(error)
          this.users = []
          this.loading = false
        })
      },
    },
    created () {
      this.init()
    }
  }
</script>